import * as React from 'react'
import { memo } from 'react'
const SvgTag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20.011 20"
  >
    <path d="M11.78 19.638a1.183 1.183 0 0 1-.866.362 1.18 1.18 0 0 1-.865-.362L.355 9.944a1.125 1.125 0 0 1-.279-.425 1.427 1.427 0 0 1-.077-.469V1.192A1.156 1.156 0 0 1 .34.34a1.156 1.156 0 0 1 .852-.341H9.05a1.61 1.61 0 0 1 .474.073 1.133 1.133 0 0 1 .442.262l9.651 9.651a1.256 1.256 0 0 1 .393.9 1.2 1.2 0 0 1-.373.892ZM3.921 5.06a1.105 1.105 0 0 0 .814-.346 1.124 1.124 0 0 0 .342-.818 1.113 1.113 0 0 0-.34-.814 1.108 1.108 0 0 0-.813-.342 1.125 1.125 0 0 0-.824.34 1.107 1.107 0 0 0-.342.813 1.13 1.13 0 0 0 .34.819 1.111 1.111 0 0 0 .823.348Z" />
  </svg>
)
const Memo = memo(SvgTag)
export default Memo
